// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";

var order_history = Config$PorterinUtils.wag_url + "/order-history/orders";

var date_format = "MMM DD YYYY, hh:mm A";

export {
  order_history ,
  date_format ,
}
/* Config-PorterinUtils Not a pure module */
